import { Injectable } from '@angular/core';
import { AlertMessage, AlertMessageType, ToastType } from '@models';
import { ToastrService } from 'ngx-toastr';
import * as Sentry from '@sentry/browser';

@Injectable()
export class AlertMessageService {

  constructor(private toastr: ToastrService) { }

  static genericError(reason: string) {
    const arr = reason.split(' ');
    return {
      code: arr.splice(0, 1).join(' '),
      message: arr.join(' '),
    };
  }

  public extractMessage(err: any): string {
    const bodyError = err.error ? err.error.error || err.error[0] : null;

    return bodyError || AlertMessageService.genericError(err.statusText).message;
  }

  public showToastr(err: AlertMessage | any, params?: any[], defaultType = AlertMessageType.ERROR) {
    if (err && err instanceof AlertMessage) {
      const message = this.interpolateString(err.msg, params);
      Sentry.captureMessage(`${message}: ${err}`);
      this.toastr.show(this.addPeriodIfDoesntExist(message), 'Atenção',
        {
          progressAnimation: 'decreasing',
        }, ToastType[err.type]);
    } else {
      const mappedError = this.extractMessage(err);
      Sentry.captureMessage(`${mappedError}: ${err.url}`);
      this.toastr.show(this.addPeriodIfDoesntExist(mappedError), 'Atenção',
        {
          progressAnimation: 'decreasing',
        }, ToastType[defaultType]);
    }
  }

  public interpolateString(schema: string, params?: any[] | object): string {
    let path = schema;
    if (params) {
        for (const i in params) {
            if (params.hasOwnProperty(i)) {
                const param = params[i];
                let value = '';
                if (param !== null && param !== undefined) {
                    value = param.toString();
                }
                path = path.split(`{{${i}}}`).join(value);
            }
        }
    }
    return path;
  }

  private addPeriodIfDoesntExist(msg: string) {
    return ['.', '!'].includes(msg[msg.length - 1]) ? msg : msg + '.';
  }

}
